import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-lens-details',
  templateUrl: './lens-details.component.html',
  styleUrls: ['./lens-details.component.css', '../order.component.css'],
  host: { class: 'ao-fields' },
})
export class LensDetailsComponent implements OnInit {
  @Input() orderForm: FormGroup;
  @Output() saveOrder = new EventEmitter<{ destination: string }>();

  ngOnInit(): void {}

  get polControl(): FormControl | null {
    return this.asFormControl('pol');
  }

  get lensesPriceControl(): FormControl | null {
    return this.asFormControl('products.0.lensesPrice');
  }

  get tintPriceControl(): FormControl | null {
    return this.asFormControl('products.0.tintPrice');
  }

  get coatingsPriceControl(): FormControl | null {
    return this.asFormControl('products.0.coatingsPrice');
  }

  get miscPriceControl(): FormControl | null {
    return this.asFormControl('products.0.miscPrice');
  }

  onSave(destination: string): void {
    this.saveOrder.emit({ destination });
  }

  private asFormControl(path: string): FormControl | null {
    const control = this.orderForm?.get(path);
    return control ? (control as FormControl) : null;
  }
}
